import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chips } from '../../../../components/chips/chips';

interface StatusBadgeProps {
  module: any;
  skipped: boolean;
}
export function SummaryStatusBadge({ module, skipped }: StatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <>
      {(!module && (
        <Chips
          color="error"
          label={t('assessment.ID_MODULE_INCOMPLETE')}
          size="small"
          variant="filled"
        />
      )) ||
        (skipped && (
          <Chips
            color="warning"
            label={t('assessment.ID_MODULE_SKIPPED')}
            size="small"
            variant="filled"
          />
        )) || (
          <Chips
            color="success"
            label={t('assessment.ID_MODULE_COMPLETE')}
            size="small"
            variant="filled"
          />
        )}
    </>
  );
}
